import { LaneLine } from "../models";

export function cloneLaneLines(lanes: LaneLine[]): LaneLine[] {
    return lanes.map((l) => new LaneLine(l));
}

export function laneLinesEqual(a: LaneLine[], b: LaneLine[]): boolean {
    if (a.length !== b.length) return false;

    const key = (l: LaneLine) =>
        JSON.stringify({
            id: l.id ?? null,
            name: l.name ?? null,
            color: l.color ?? null,
            laneNumber: l.laneNumber ?? null,
            turnType: l.turnType ?? null,
            points: (l.points ?? []).map((p) => [p.x, p.y]),
        });

    const counts = new Map<string, number>();
    for (const l of b) {
        const k = key(l);
        counts.set(k, (counts.get(k) ?? 0) + 1);
    }
    for (const l of a) {
        const k = key(l);
        const remaining = counts.get(k);
        if (!remaining) return false;
        counts.set(k, remaining - 1);
    }
    return true;
}
